import { CardContent } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { Card, Form, Modal } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import { useHistory } from "react-router-dom";
import successful from "../../../Assets/Images/Souvenir/successful.png";
import unsuccessful from "../../../Assets/Images/Souvenir/successful.png";
import swal from "sweetalert";

const PaymentSuccessfulModal = (props) => {
  const history = useHistory();

  const [cvv, setCvv] = useState("");
  const [expireDate, setExpireDate] = useState("");
  const [cardNo, setCardNo] = useState("");
  const [holderName, setHolderName] = useState("");

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="modalBody modalBodyStyle">
        <div style={{ backgroundColor: "#25272b" }} sx={{ minWidth: 275 }}>
          <div className="d-flex justify-content-end p-2">
            <button
              onClick={props.onHide}
              className="closeNotificationDrop text-center"
            >
              X
            </button>
          </div>
          <div>
            <div className="d-flex justify-content-center">
              <img src={successful} className="img-fluid" alt="" />
            </div>
            <div className="text-center">
              <h3 className="text-warning fw-bold">Payment Successful!</h3>
              <p className="text-light">Transaction Number: {props?.cardno}</p>
            </div>
            <div className="d-flex justify-content-center">
              <div className="underlineWhite"></div>
            </div>

            <div className="d-flex justify-content-center text-light">
              <div className="mx-3">
                <p>Amount </p>
                {/* <p>Bank</p> */}
              </div>
              <div className="mx-3">
                <p>: {props?.amount} $ </p>
                {/* <p>:Dhaka</p> */}
              </div>
            </div>

            <div className="d-flex justify-content-center p-4">
              <button
                className="btn btn-warning w-25 border-3"
                onClick={props.onHide}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PaymentSuccessfulModal;
